// 矩阵
import Layout from "@/layout/layout.vue";

const configurationCenter = {
    // 加载路径
    path:"/configurationCenter",
    // 加载组件
    component:Layout,
    // 重定向路径
    redirect:"noRedirect",
    // 路由名称
    name:"平台标准配置中心",
    children:[
        {
            path:"faultManage",
            name:"平台故障项管理",
            component: ()=>import("@/views/configurationCenter/faultManage/index.vue"),
            meta:{title:"平台故障项管理",noCache:true}
        },
    ]
}

export default configurationCenter;